export default __webpack_public_path__ + "file/Fiche-EN-Produit-Puroak-Copeaux.asset.a13675eb.pdf";